@if (faqs().length === 0) {
<app-not-found [isLoading]="loading()">
  <p class="text-zinc-500">등록된 FAQ가 없습니다.</p>
</app-not-found>
} @else {
<div class="flex flex-col gap-3">
  @for (faq of faqs(); track faq.id) {
  <div class="bg-zinc-50 rounded-xl overflow-hidden">
    <button
      (click)="toggleFaq(faq.id)"
      class="cursor-pointer w-full flex items-center gap-3 p-5 text-left transition-colors hover:bg-zinc-100">
      <div class="w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center shrink-0">
        <span class="text-white font-bold text-sm">Q</span>
      </div>
      <div class="flex flex-1">
        <p class="text-zinc-800 font-semibold">{{ faq.question }}</p>
      </div>
      <app-icon
        name="material-symbols:chevron-right-rounded"
        class="size-5! text-zinc-800 shrink-0"
        [@rotateChevron]="isOpen(faq.id) ? 'up' : 'down'" />
    </button>

    <!-- 답변 영역 -->
    <div [@expandCollapse]="isOpen(faq.id) ? 'expanded' : 'collapsed'">
      <div class="bg-zinc-50 p-5 pt-0">
        <div class="flex items-start gap-3">
          <div class="shrink-0 w-8 h-8 bg-zinc-400 rounded-full flex items-center justify-center mt-0.5">
            <span class="text-white font-bold text-sm">A</span>
          </div>
          <div class="flex-1">
            <div class="editor-content text-zinc-600 text-sm leading-relaxed" [innerHTML]="faq.answer | safeHtml"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
}
